import { render, staticRenderFns } from "./homomorphic.vue?vue&type=template&id=84f577ba&scoped=true&"
import script from "./homomorphic.vue?vue&type=script&lang=js&"
export * from "./homomorphic.vue?vue&type=script&lang=js&"
import style0 from "./homomorphic.vue?vue&type=style&index=0&id=84f577ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84f577ba",
  null
  
)

export default component.exports